/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSessionGetResponseFromDiscriminatorValue, type SessionGetResponse } from '../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /session
 */
export interface SessionRequestBuilder extends BaseRequestBuilder<SessionRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SessionGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SessionGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     post(requestConfiguration?: RequestConfiguration<SessionRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<SessionRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface SessionRequestBuilderPostQueryParameters {
    token?: string;
}
/**
 * Uri template for the request builder.
 */
export const SessionRequestBuilderUriTemplate = "{+baseurl}/session{?token*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const SessionRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SessionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        adapterMethodName: "send",
        responseBodyFactory:  createSessionGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: SessionRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
